import Vue from 'vue';
import { IMaskComponent } from 'vue-imask';

Vue.component('ImaskInput', IMaskComponent);
